import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useFetchUser } from "../../methods/auth/auth";
import { removeCookie } from "../../methods/cookies/cookies";

const IsLoggedIn = ({ children, adminLevel = false }) => {
  const fetchUser = useFetchUser();
  const auth = useSelector((state) => state.user);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true); // Track loading state

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true); // Start loading
      await fetchUser(); // Fetch user data
      setIsLoading(false); // Stop loading
    };
    checkAuth();
  }, []);

  // Wait until user authentication is determined
  if (isLoading) {
    return <p>Loading...</p>; // Show a loader instead of redirecting immediately
  }

  if (!auth.user) {
    removeCookie("launchcore");
    removeCookie("launchcore_refresh");
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (adminLevel && !["ADMIN", "EMPLOYEE"].includes(auth?.user?.role)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default IsLoggedIn;
